import { LOCATION_CHANGE } from 'react-router-redux';
import { Action, UntypedAction } from 'typed/actions';
import {
    BusinessModelCanvasArea, BusinessModelCanvasItemType, BusinessReviewSectionType, BusinessReviewSessionStatus, GoalMetricValueSource, GoalMetricValueType, MeetingStatus,
    PerformanceIndicatorValueSource, PeriodType, RequestStatus, StrategicGoalMilestoneAchievability, StrategicGoalMilestoneFinalStatus, StrategicGoalMilestoneStatus,
    StrategicProgramFinalStatus, StrategicProgramRiskLevel, StrategicProgramStatus, StrategicProgramUpdateFrequency, StrategyDescriptionStatus, StrategyExecutionCustomFieldType,
    StrategyExecutionSecondaryStatusUpdateType, StrategyExecutionType, StrategyNamingType, StrategyProcessSubthemeType, StrategyProgressCalculationMethod,
    StrategyProgressCalculationSource, StrategyPublishingLevel, StrategyPublishingType, StrategyTaxonomy, StrategyView, defaults, entities
} from 'typed/api';
import {
    childrenReducer, combineReducers, entityAddAllReducer, entityAddReducer,
    entityDeleteAllReducer, entityDeleteReducer, entityEditAllReducer, entityEditReducer, entityLoadAllReducer, entityLoadReducer,
    entityVoidAllReducer, networkActionReducer, sortableEntitiesReducer, sortedEntitiesReducer, switchReducers, synchronizableEnumReducer
} from './utils';
import { Period, deepAssign } from 'typed/utils';
import {
    BusinessReviewSettings, DefaultBusinessReviewSettings, DefaultStrategyActionListContentSettings, DefaultStrategyContentSettings, DefaultStrategyFilter,
    DefaultStrategyOrganizationStructureFilter, DefaultStrategyPlannerFilter, OTHER_ITEMS_GOAL_ID, StrategyFilter, TEAMS_AND_USERS_STRATEGY_ID,
    extractStrategyFilterFromQuery, getMilestoneChildren, getProgramChildren
} from 'typed/components/strategy/utils';
import { ActionType, REDUCER_EXPIRATION_TIMEOUT } from 'utils/constants';

// TODO find a way to infer this
const
    ACTIVE_MILESTONE_PERIOD = new Period(PeriodType.MONTH).previous.start,

    cas = defaults.NetworkArrayOf(defaults.BusinessModelCanvasArea),
    v = defaults.BusinessModelReport,
    vs = defaults.NetworkArrayOf(v),
    ps = [] as entities.BusinessModelCanvasItem[],
    sprc = defaults.StrategyProcessReport,
    sprcs = defaults.NetworkArrayOf(sprc),
    sprts: entities.StrategyProcessThemeReport[] = [],
    spp = defaults.StrategyProcessPhaseReport,
    spps = defaults.NetworkArrayOf(spp),
    sppca: entities.StrategyProcessPhaseContent[] = [],
    ts = defaults.NetworkArrayOf(defaults.StrategyTaxonomy),
    sds = defaults.NetworkArrayOf(defaults.StrategyDescriptionReport) as entities.StrategyNetworkArray,
    sss = defaults.NetworkArrayOf(defaults.StrategyDescriptionStatus),
    spt = defaults.NetworkArrayOf(defaults.StrategyPublishingType),
    snt = defaults.NetworkArrayOf(defaults.StrategyNamingType),
    sdps = [] as entities.StrategyDescriptionParticipator[],
    sdas = [] as entities.StrategyDescriptionAdministrator[],
    sdgm: entities.GoalMetricReport[] = [],
    sg = defaults.StrategicGoalReport,
    sgs = defaults.NetworkArrayOf(sg),
    csfa: entities.StrategicGoalCriticalSuccessFactorReport[] = [],
    gm: entities.GoalMetricReport[] = [],
    gmn: entities.GoalMetricReport | null = null,
    sms = defaults.NetworkArrayOf(defaults.StrategicGoalMilestoneReport),
    smcs = defaults.NetworkPaginationSliceOf(defaults.StrategicGoalMilestoneComment),
    smms = defaults.NetworkPaginationSliceOf(defaults.GoalMetricReport),
    smus = defaults.NetworkPaginationSliceOf(defaults.StrategicGoalMilestoneStatusUpdate),
    smsus = defaults.NetworkPaginationSliceOf(defaults.StrategicGoalMilestoneSecondaryStatusUpdate),
    gma = defaults.NetworkArrayOf(defaults.StrategicGoalMilestoneAchievability),
    gms = defaults.NetworkArrayOf(defaults.StrategicGoalMilestoneStatus),
    gmfs = defaults.NetworkArrayOf(defaults.StrategicGoalMilestoneFinalStatus),
    sps = defaults.NetworkArrayOf(defaults.StrategicProgramReport),
    spsos: entities.StrategicProgramSecondaryOwner[] = [],
    spcs = defaults.NetworkPaginationSliceOf(defaults.StrategicProgramComment),
    spus = defaults.NetworkPaginationSliceOf(defaults.StrategicProgramStatusUpdateReport),
    spurs = defaults.NetworkPaginationSliceOf(defaults.StrategicProgramStatusUpdateRecipient),
    sprs = defaults.NetworkArrayOf(defaults.StrategicProgramRiskLevel),
    spss = defaults.NetworkArrayOf(defaults.StrategicProgramStatus),
    spfs = defaults.NetworkArrayOf(defaults.StrategicProgramFinalStatus),
    spufs = defaults.NetworkArrayOf(defaults.StrategicProgramUpdateFrequency),
    spl = defaults.NetworkArrayOf(defaults.StrategyPublishingLevel),
    set = defaults.NetworkArrayOf(defaults.StrategyExecutionType),
    sfs = defaults.NetworkArrayOf(defaults.StrategyFreeNodeReport),
    brs = defaults.NetworkArrayOf(defaults.BusinessReviewSchedule),
    brss = defaults.NetworkPaginationSliceOf(defaults.BusinessReviewSession),
    brts = defaults.NetworkArrayOf(defaults.BusinessReviewTemplateReport),
    brsts = [] as entities.BusinessReviewStep[],
    brsss = defaults.NetworkArrayOf(defaults.BusinessReviewSessionStatus),
    brus = defaults.BusinessReviewUserSettings,
    bruss = defaults.NetworkArrayOf(brus),
    bres = defaults.NetworkArrayOf(defaults.BusinessReviewExcludedSection),
    secf = defaults.NetworkArrayOf(defaults.StrategyExecutionCustomFieldReport),
    secfo = [] as entities.StrategyExecutionCustomFieldOption[],
    secfl = [] as entities.StrategyExecutionCustomFieldLink[],
    secft = defaults.NetworkArrayOf(defaults.StrategyExecutionCustomFieldType),
    seces = defaults.NetworkArrayOf(defaults.StrategyExecutionCustomEntity),
    seceds: entities.StrategyExecutionCustomEntityData[] = [],
    smtl = [] as entities.StrategicGoalMilestoneTeamLink[],
    smsos = [] as entities.StrategicGoalMilestoneSecondaryOwner[],
    ssva = defaults.NetworkArrayOf(defaults.StrategySavedView),

    strategy = combineReducers({
        businessModelCanvasAreas: switchReducers(cas,
            entityLoadAllReducer(cas, 'LOAD_ALL_BUSINESS_MODEL_CANVAS_AREAS', BusinessModelCanvasArea as any, 'BusinessModelCanvasArea'),
            entityEditReducer(cas, 'EDIT_BUSINESS_MODEL_CANVAS_AREA')
        ),
        businessModels: sortedEntitiesReducer(vs, 'Name', switchReducers(vs,
            entityLoadAllReducer(vs, 'LOAD_ALL_BUSINESS_MODELS'),
            entityAddReducer(vs, 'ADD_BUSINESS_MODEL'),
            entityEditReducer(vs, 'EDIT_BUSINESS_MODEL'),
            childrenReducer(vs,
                combineReducers(v, {
                    CanvasItems: sortedEntitiesReducer(ps, 'Name', switchReducers(ps,
                        entityLoadAllReducer(ps, 'LOAD_ALL_BUSINESS_MODEL_CANVAS_ITEMS'),
                        entityAddReducer(ps, 'ADD_BUSINESS_MODEL_CANVAS_ITEM'),
                        entityEditReducer(ps, 'EDIT_BUSINESS_MODEL_CANVAS_ITEM'),
                        entityDeleteReducer(ps, 'DELETE_BUSINESS_MODEL_CANVAS_ITEM'),
                        entityVoidAllReducer(ps, 'VOID_ALL_BUSINESS_MODEL_CANVAS_ITEMS')
                    )
                    )
                }),
                (state, action) => state.Data.getIndexByID(action.payload && ((action.payload as any).parentID || (action.payload as any).entityID))
            ),
            entityDeleteReducer(vs, 'DELETE_BUSINESS_MODEL'),
            entityVoidAllReducer(vs, 'VOID_ALL_BUSINESS_MODELS')
        )
        ),
        businessModelCanvasItemTypes: synchronizableEnumReducer(
            defaults.NetworkArrayOf(defaults.BusinessModelCanvasItemType),
            'LOAD_ALL_BUSINESS_MODEL_CANVAS_ITEM_TYPES',
            BusinessModelCanvasItemType as any,
            'BusinessModelCanvasItemType'
        ),
        strategyHealthReports: entityLoadAllReducer(defaults.NetworkArrayOf(defaults.StrategyHealthReport), 'LOAD_ALL_STRATEGY_HEALTH_REPORTS'),
        strategyProcesses: sortedEntitiesReducer(sprcs, 'Name', switchReducers(sprcs,
            entityLoadAllReducer(sprcs, 'LOAD_ALL_STRATEGY_PROCESSES'),
            entityAddReducer(sprcs, 'ADD_STRATEGY_PROCESS'),
            entityEditReducer(sprcs, 'EDIT_STRATEGY_PROCESS'),
            childrenReducer(sprcs,
                combineReducers(sprc, {
                    Themes: sortableEntitiesReducer(sprts, null, switchReducers(sprts,
                        entityAddAllReducer(sprts, 'ADD_ALL_STRATEGY_PROCESS_THEMES'),
                        entityEditAllReducer(sprts, 'EDIT_ALL_STRATEGY_PROCESS_THEMES'),
                        entityDeleteAllReducer(sprts, 'DELETE_ALL_STRATEGY_PROCESS_THEMES')
                    ))
                }),
                (state, action) => state.Data.getIndexByID(action.payload && (action.payload as any).parentID)
            ),
            entityDeleteReducer(sprcs, 'DELETE_STRATEGY_PROCESS')
        )),
        strategyProcessSubthemeTypes: synchronizableEnumReducer(
            defaults.NetworkArrayOf(defaults.StrategyProcessSubthemeType),
            'LOAD_ALL_STRATEGY_PROCESS_SUBTHEME_TYPES',
            StrategyProcessSubthemeType as any,
            'StrategyProcessSubthemeType'
        ),
        strategyProcessPhases: sortedEntitiesReducer(spps, 'Title', switchReducers(spps,
            entityLoadAllReducer(spps, 'LOAD_ALL_STRATEGY_PROCESS_PHASES'),
            entityAddReducer(spps, 'ADD_STRATEGY_PROCESS_PHASE'),
            entityEditReducer(spps, 'EDIT_STRATEGY_PROCESS_PHASE'),
            childrenReducer(spps,
                combineReducers(spp, {
                    PhaseContents: switchReducers(sppca,
                        entityAddReducer(sppca, 'ADD_STRATEGY_PROCESS_PHASE_CONTENT'),
                        entityEditReducer(sppca, 'EDIT_STRATEGY_PROCESS_PHASE_CONTENT'),
                        entityDeleteReducer(sppca, 'DELETE_STRATEGY_PROCESS_PHASE_CONTENT')
                    )
                }),
                (state, action) => state.Data.getIndexByID(action.payload && (action.payload as any).parentID)
            ),
            entityDeleteReducer(spps, 'DELETE_STRATEGY_PROCESS_PHASE')
        )),
        strategyTaxonomies: switchReducers(ts,
            entityLoadAllReducer(ts, 'LOAD_ALL_STRATEGY_TAXONOMIES', StrategyTaxonomy as any, 'StrategyTaxonomy'),
            entityEditAllReducer(ts, 'EDIT_ALL_STRATEGY_TAXONOMIES'),
            entityEditReducer(ts, 'EDIT_STRATEGY_TAXONOMY')
        ),
        strategyDescriptions: sortedEntitiesReducer(sds, 'Name', switchReducers(sds,
            (state, action) => {
                const nextState = switchReducers(sds,
                    entityLoadAllReducer(sds, 'LOAD_ALL_STRATEGY_DESCRIPTIONS'),
                    entityLoadReducer(sds, 'LOAD_STRATEGY_DESCRIPTION'),
                    entityLoadReducer(sds, 'PUBLISH_STRATEGY_DESCRIPTION'),
                    entityLoadReducer(sds, 'AUTOMATICALLY_PUBLISH_STRATEGY')
                )(state, action);

                if ((action.type === 'LOAD_ALL_STRATEGY_DESCRIPTIONS' || action.type === 'LOAD_STRATEGY_DESCRIPTION') && action.payload.status === RequestStatus.SUCCEEDED) {
                    return deepAssign(nextState, {
                        Data: nextState.Data.leftJoin((state || sds)?.Data, ({ ID }) => ID, ({ ID }) => ID, (_, oldStrategy) => {
                            if (oldStrategy?.Custom.createdInRoadmap) { return { Custom: { createdInRoadmap: true } }; }
                            return {};
                        })
                    });
                }

                return nextState;
            },
            entityAddReducer(sds, 'ADD_STRATEGY_DESCRIPTION'),
            entityEditReducer(sds, 'EDIT_STRATEGY_DESCRIPTION'),
            entityEditAllReducer(sds, 'EDIT_ALL_STRATEGY_DESCRIPTIONS'),
            networkActionReducer(sds, 'SET_STRATEGY_DESCRIPTION_STATUS'),
            childrenReducer(sds,
                combineReducers(defaults.StrategyDescriptionReport, {
                    Participators: switchReducers(sdps,
                        entityAddAllReducer(sdps, 'ADD_ALL_STRATEGY_DESCRIPTION_PARTICIPATORS'),
                        entityDeleteAllReducer(sdps, 'DELETE_ALL_STRATEGY_DESCRIPTION_PARTICIPATORS'),
                        (state, action: Action<'INVITE_STRATEGY_DESCRIPTION_PARTICIPATORS'>) => {
                            if (action.type === 'INVITE_STRATEGY_DESCRIPTION_PARTICIPATORS' && action.payload.status === RequestStatus.SUCCEEDED) {
                                return (state || []).map(participator =>
                                    action.payload.userIDs.includes(participator.UserID) ? { ...participator, InviteSent: new Date() } : participator
                                );
                            }

                            return state || [];
                        }
                    ),
                    Admins: switchReducers(sdas,
                        entityAddAllReducer(sdas, 'ADD_ALL_STRATEGY_DESCRIPTION_ADMINISTRATORS'),
                        entityDeleteAllReducer(sdas, 'DELETE_ALL_STRATEGY_DESCRIPTION_ADMINISTRATORS')
                    ),
                    Metrics: switchReducers(sdgm,
                        entityLoadReducer(sdgm, 'LOAD_STRATEGY_METRIC'),
                        entityEditReducer(sdgm, 'EDIT_STRATEGY_METRIC'),
                        (state, action: Action<'ADD_STRATEGY_METRIC'>) => {
                            const newState: entities.GoalMetricReport[] = (state || sdgm).copy();

                            if (action.type === 'ADD_STRATEGY_METRIC') {
                                const entity = action.payload.status !== RequestStatus.SUCCEEDED ?
                                    deepAssign(action.payload.entity, { Custom: { status: action.payload.status } }) :
                                    deepAssign(action.payload.response, { Custom: { internalID: action.payload.entity.Custom.internalID } });

                                let entityIndex = newState.getIndexByID(entity.ID);
                                if (entityIndex < 0) { entityIndex = newState.length; }

                                return deepAssign(newState, { [entityIndex]: entity });
                            }

                            return newState;
                        },
                        entityDeleteReducer(sdgm, 'DELETE_STRATEGY_METRIC')
                    )
                }),
                (state, action) => state.Data.getIndexByID(action.payload && (action.payload as any).parentID)
            ),
            (state, action) => {
                let newState = state || sds;

                if (action.type === 'SET_STRATEGY_DESCRIPTION_STATUS' && action.payload.status === RequestStatus.SUCCEEDED) {
                    if (action.payload.statusID === StrategyDescriptionStatus.ARCHIVED) {
                        newState = deepAssign(newState, { Custom: { status: RequestStatus.UNSYNCED } });
                    }

                    return deepAssign(newState, {
                        Data: {
                            [newState.Data.getIndexByID(action.payload.entityID)]: {
                                StatusID: action.payload.statusID,
                                Metrics: (newState.Data.getByID(action.payload.entityID)?.Metrics || []).map(() => ({ Expired: false }))
                            }
                        }
                    });
                }


                if (action.type === 'SET_GOAL_DEFAULT_CUSTOM_LABEL' && action.payload.status === RequestStatus.SUCCEEDED) {
                    return deepAssign(newState, {
                        Data: {
                            [newState.Data.getIndexByID(action.payload.entityID)]: {
                                GoalDefaultCustomLabel: action.payload.customLabel
                            }
                        }
                    });
                }

                if (action.type === 'COPY_STRATEGY_DESCRIPTION') {
                    if (action.payload.status === RequestStatus.SUCCEEDED) {
                        return deepAssign(newState, { Custom: { status: RequestStatus.UNSYNCED, copy: false } });
                    }
                    else if (action.payload.status === RequestStatus.FAILED) {
                        return deepAssign(newState, { Custom: { copy: false } });
                    }
                    else {
                        return deepAssign(newState, { Custom: { copy: true } });
                    }
                }

                if (action.type === 'DELETE_COMPANY_FUNCTION' ||
                    action.type === 'DELETE_COMPANY_LEGAL_ENTITY') {
                    return entityVoidAllReducer(sds, action.type)(state, action);
                }

                if (action.type === 'ADD_STRATEGIC_GOAL' && action.payload.status === RequestStatus.SUCCEEDED && !newState.Data.getByID(TEAMS_AND_USERS_STRATEGY_ID) ||
                    action.type === 'ADD_STRATEGIC_GOAL_MILESTONE' && action.payload.status === RequestStatus.SUCCEEDED && !newState.Data.getByID(TEAMS_AND_USERS_STRATEGY_ID) ||
                    action.type === 'DELETE_STRATEGY_DESCRIPTION' && action.payload.status === RequestStatus.SUCCEEDED ||
                    action.type === 'CREATE_DIALOG_SCHEDULE_BATCH_RESULT_STRATEGY' && action.payload.status === RequestStatus.SUCCEEDED) {
                    return deepAssign(newState, { Custom: { status: RequestStatus.UNSYNCED } });
                }

                if (action.type === 'EDIT_PERFORMANCE_INDICATOR_SUCCESS') {
                    return deepAssign(newState, {
                        Data: newState.Data.map(({ Metrics }) => ({
                            Metrics: Metrics.map(metric => ({
                                PerformancePerspectiveGroupID: metric.IndicatorID !== (action as any).indicatorID ?
                                    metric.PerformancePerspectiveGroupID :
                                    (action.indicator as entities.PerformanceIndicatorReport).PerformancePerspectiveGroupID
                            }))
                        }))
                    });
                }

                if (action.type === ActionType.MERGE_ALL_PERFORMANCE_INDICATOR_DAY_DATA_SUCCESS ||
                    action.type === ActionType.MERGE_ALL_PERFORMANCE_INDICATOR_WEEK_DATA_SUCCESS ||
                    action.type === ActionType.MERGE_ALL_PERFORMANCE_INDICATOR_MONTH_DATA_SUCCESS ||
                    action.type === ActionType.MERGE_ALL_PERFORMANCE_INDICATOR_QUARTER_DATA_SUCCESS ||
                    action.type === ActionType.MERGE_ALL_PERFORMANCE_INDICATOR_YEAR_DATA_SUCCESS) {
                    const
                        corporateStructureLink = defaults.CorporateStructureLink,
                        corporateStructureProperties = Object.keys(corporateStructureLink).filter(key =>
                            Object.prototype.hasOwnProperty.call(corporateStructureLink, key) && key !== 'Custom'
                        );

                    return deepAssign(newState, {
                        Data: newState.Data.map(({ Metrics }) => ({
                            Metrics: Metrics.map(metric => ({
                                Expired: metric.Expired ?
                                    !(action as any).entities.some((entity: entities.PerformanceIndicatorDataBase) =>
                                        entity.PeriodTypeID === metric.PeriodTypeID &&
                                            entity.KeyPerformanceIndicatorID === metric.IndicatorID &&
                                            entity.CorporateStructureLink && corporateStructureProperties.every(property =>
                                            (entity.CorporateStructureLink as any)[property] === (metric.CorporateStructureLink as any)[property]
                                        ) &&
                                            entity.ActualSourceID === PerformanceIndicatorValueSource.MANUAL &&
                                            +entity.Date === +new Period(metric.PeriodTypeID).previous.start
                                    ) :
                                    false
                            }))
                        }))
                    });
                }

                return newState;
            },
            entityDeleteReducer(sds, 'DELETE_STRATEGY_DESCRIPTION'),
            entityVoidAllReducer(sds, 'VOID_ALL_STRATEGY_DESCRIPTIONS')
        )),
        strategyDescriptionStatuses: synchronizableEnumReducer(sss, 'LOAD_ALL_STRATEGY_DESCRIPTION_STATUSES', StrategyDescriptionStatus as any, 'StrategyDescriptionStatus'),
        strategyPublishingTypes: synchronizableEnumReducer(spt, 'LOAD_ALL_STRATEGY_PUBLISHING_TYPES', StrategyPublishingType as any, 'StrategyPublishingType'),
        strategyNamingTypes: synchronizableEnumReducer(snt, 'LOAD_ALL_STRATEGY_NAMING_TYPES', StrategyNamingType as any, 'StrategyNamingType'),
        strategicGoals: sortedEntitiesReducer(sgs, 'Name', switchReducers(sgs,
            (state, action) => {
                const nextState = switchReducers(sgs,
                    entityLoadAllReducer(sgs, 'LOAD_ALL_STRATEGIC_GOALS'),
                    entityLoadReducer(sgs, 'LOAD_STRATEGIC_GOAL')
                )(state, action);

                if ((action.type === 'LOAD_ALL_STRATEGIC_GOALS' || action.type === 'LOAD_STRATEGIC_GOAL') && action.payload.status === RequestStatus.SUCCEEDED) {
                    return deepAssign(nextState, {
                        Data: nextState.Data.leftJoin((state || sgs)?.Data, ({ ID }) => ID, ({ ID }) => ID, (_, oldGoal) => {
                            if (oldGoal?.Custom.createdInRoadmap) { return { Custom: { createdInRoadmap: true } }; }
                            return {};
                        })
                    });
                }

                return nextState;
            },
            entityAddReducer(sgs, 'ADD_STRATEGIC_GOAL'),
            entityEditReducer(sgs, 'EDIT_STRATEGIC_GOAL'),
            childrenReducer(sgs,
                combineReducers(sg, {
                    Custom: (state, action) => {
                        const nextState = state || sg.Custom;

                        if (action.type === 'SET_GOAL_CUSTOM_JOURNEY_RANGE') {
                            return deepAssign(nextState, {
                                journeyStartDate: action.payload.startDate,
                                journeyEndDate: action.payload.endDate
                            });
                        }

                        if (action.type === 'SET_STRATEGIC_GOAL_ROADMAP_START_DATE') {
                            return deepAssign(nextState, {
                                roadmapStartDates: {
                                    [action.payload.teamID || 0]: action.payload.startDate
                                }
                            });
                        }

                        if (action.type === 'CLEAR_STRATEGIC_GOAL_ROADMAP_START_DATES') {
                            return { ...nextState, roadmapStartDates: {} };
                        }

                        return nextState;
                    },
                    Metrics: switchReducers(gm,
                        entityLoadReducer(gm, 'LOAD_GOAL_METRIC'),
                        entityAddAllReducer(gm, 'ADD_ALL_GOAL_METRICS'),
                        entityEditReducer(gm, 'EDIT_GOAL_METRIC'),
                        entityEditAllReducer(gm, 'EDIT_ALL_GOAL_METRICS'),
                        entityDeleteReducer(gm, 'DELETE_GOAL_METRIC'),
                        entityDeleteAllReducer(gm, 'DELETE_ALL_GOAL_METRICS'),
                        (state, action) => {
                            const newState = (state || gm).copy();

                            if (action.type === 'ADD_GOAL_METRIC') {
                                const entity = action.payload.status !== RequestStatus.SUCCEEDED ?
                                    deepAssign(action.payload.entity, { Custom: { status: action.payload.status } }) :
                                    deepAssign(action.payload.response, { Custom: { internalID: action.payload.entity.Custom.internalID } });

                                let entityIndex = newState.getIndexByID(entity.ID);
                                if (entityIndex < 0) { entityIndex = newState.length; }

                                return deepAssign(newState, { [entityIndex]: entity });
                            }

                            return newState;
                        }
                    ),
                    CriticalSuccessFactors: switchReducers(csfa,
                        entityAddReducer(csfa, 'ADD_CRITICAL_SUCCESS_FACTOR'),
                        entityAddAllReducer(csfa, 'ADD_ALL_CRITICAL_SUCCESS_FACTORS'),
                        entityEditReducer(csfa, 'EDIT_CRITICAL_SUCCESS_FACTOR'),
                        entityEditAllReducer(csfa, 'EDIT_ALL_CRITICAL_SUCCESS_FACTORS'),
                        entityDeleteReducer(csfa, 'DELETE_CRITICAL_SUCCESS_FACTOR'),
                        entityDeleteAllReducer(csfa, 'DELETE_ALL_CRITICAL_SUCCESS_FACTORS')
                    )
                }),
                (state, action) => state.Data.getIndexByID(action.payload && (action.payload as any).parentID)
            ),
            (state, action) => {
                let newState = state || sgs;

                if ((
                    action.type === 'COPY_STRATEGY_DESCRIPTION' ||
                    action.type === 'PUBLISH_STRATEGY_DESCRIPTION' ||
                    action.type === 'AUTOMATICALLY_PUBLISH_STRATEGY' ||
                    action.type === 'CREATE_DIALOG_SCHEDULE_BATCH_RESULT_STRATEGY'
                ) && action.payload.status === RequestStatus.SUCCEEDED) {

                    return deepAssign(newState, { Custom: { status: RequestStatus.UNSYNCED } });
                }

                if ((action.type === 'ADD_ALL_GOAL_METRICS' || action.type === 'ADD_GOAL_METRIC') && action.payload.status === RequestStatus.PENDING) {
                    const goal = newState.Data.getByID(action.payload.parentID)!;

                    newState = deepAssign(newState, {
                        Data: {
                            [newState.Data.getIndexByID(action.payload.parentID)]: {
                                Custom: {
                                    ...goal.Custom,
                                    isMetricSaving: true
                                }
                            }
                        }
                    });

                    return newState;
                }

                if (action.type === 'ADD_ALL_GOAL_METRICS' && action.payload.status === RequestStatus.SUCCEEDED) {
                    const goal = newState.Data.getByID(action.payload.parentID)!;

                    newState = deepAssign(newState, {
                        Data: {
                            [newState.Data.getIndexByID(action.payload.parentID)]: {
                                Metrics: [
                                    ...goal.Metrics.filter(({ ID }) => !action.payload.entityIDs.includes(ID)),
                                    ...action.payload.response
                                ],
                                Custom: {
                                    ...goal.Custom,
                                    isMetricSaving: false
                                }
                            }
                        }
                    });

                    return newState;
                }

                if (action.type === ActionType.MERGE_ALL_PERFORMANCE_INDICATOR_DAY_DATA_SUCCESS ||
                    action.type === ActionType.MERGE_ALL_PERFORMANCE_INDICATOR_WEEK_DATA_SUCCESS ||
                    action.type === ActionType.MERGE_ALL_PERFORMANCE_INDICATOR_MONTH_DATA_SUCCESS ||
                    action.type === ActionType.MERGE_ALL_PERFORMANCE_INDICATOR_QUARTER_DATA_SUCCESS ||
                    action.type === ActionType.MERGE_ALL_PERFORMANCE_INDICATOR_YEAR_DATA_SUCCESS) {
                    const
                        corporateStructureLink = defaults.CorporateStructureLink,
                        corporateStructureProperties = Object.keys(corporateStructureLink).filter(key =>
                            Object.prototype.hasOwnProperty.call(corporateStructureLink, key) && key !== 'Custom'
                        );

                    return deepAssign(newState, {
                        Data: newState.Data.map(({ Metrics }) => ({
                            Metrics: Metrics.map(metric => ({
                                Expired: metric.Expired ?
                                    !(action as any).entities.some((entity: entities.PerformanceIndicatorDataBase) =>
                                        entity.PeriodTypeID === metric.PeriodTypeID &&
                                        entity.KeyPerformanceIndicatorID === metric.IndicatorID &&
                                        entity.CorporateStructureLink && corporateStructureProperties.every(property =>
                                            (entity.CorporateStructureLink as any)[property] === (metric.CorporateStructureLink as any)[property]
                                        ) &&
                                        entity.ActualSourceID === PerformanceIndicatorValueSource.MANUAL &&
                                        +entity.Date === +new Period(metric.PeriodTypeID).previous.start
                                    ) :
                                    false
                            }))
                        }))
                    });
                }

                if ((action as UntypedAction).type === 'DELETE_PERFORMANCE_INDICATOR_SUCCESS') {
                    return deepAssign(newState, { Custom: { status: RequestStatus.UNSYNCED } });
                }

                if ((action as UntypedAction).type === 'EDIT_MEETING_STATUS_SUCCESS' && (action as UntypedAction).statusID === MeetingStatus.ARCHIVED) {
                    return deepAssign(newState, { Custom: { status: RequestStatus.UNSYNCED } });
                }

                return newState;
            },
            entityDeleteReducer(sgs, 'DELETE_STRATEGIC_GOAL'),
            (state, action) => {
                const nextState = state || sgs;

                if (action.type === 'EDIT_PERFORMANCE_INDICATOR_SUCCESS' || action.type === 'SET_GOAL_DEFAULT_CUSTOM_LABEL' ||
                    action.type === 'SET_STRATEGY_DESCRIPTION_STATUS' && action.payload.status === RequestStatus.SUCCEEDED) {
                    return deepAssign(nextState, { Custom: { status: RequestStatus.UNSYNCED } });
                }

                if (action.type === 'DELETE_STRATEGY_DESCRIPTION' && action.payload.status === RequestStatus.SUCCEEDED ||
                    action.type === 'ADD_STRATEGIC_GOAL_MILESTONE' && action.payload.status === RequestStatus.SUCCEEDED &&
                    !action.payload.entity.GoalID && !nextState.Data.getByID(OTHER_ITEMS_GOAL_ID)) {
                    return deepAssign(nextState, { Custom: { status: RequestStatus.UNSYNCED } });
                }

                return nextState;
            },
            entityVoidAllReducer(sgs, 'VOID_ALL_STRATEGIC_GOALS')
        )),
        strategicGoalMilestones: sortableEntitiesReducer(sms, 'GoalID', switchReducers(sms,
            entityLoadAllReducer(sms, 'LOAD_ALL_STRATEGIC_GOAL_MILESTONES'),
            (state, action) => {
                const nextState = state || sms;

                if (action.type === 'LOAD_ALL_STRATEGIC_GOAL_MILESTONES_QUIETLY' &&
                    (action.payload.status === RequestStatus.SUCCEEDED || action.payload.status === RequestStatus.FAILED)) {
                    return entityLoadAllReducer(sms, 'LOAD_ALL_STRATEGIC_GOAL_MILESTONES_QUIETLY')(nextState, action);
                }

                return nextState;
            },
            entityLoadReducer(sms, 'LOAD_STRATEGIC_GOAL_MILESTONE'),
            entityAddReducer(sms, 'ADD_STRATEGIC_GOAL_MILESTONE'),
            entityEditReducer(sms, 'EDIT_STRATEGIC_GOAL_MILESTONE'),
            entityEditAllReducer(sms, 'EDIT_ALL_STRATEGIC_GOAL_MILESTONES'),
            entityDeleteReducer(sms, 'DELETE_STRATEGIC_GOAL_MILESTONE'),
            childrenReducer(sms,
                combineReducers(defaults.StrategicGoalMilestoneReport, {
                    Comments: switchReducers(smcs,
                        entityLoadAllReducer(smcs, 'LOAD_STRATEGIC_GOAL_MILESTONE_COMMENTS_SLICE'),
                        entityAddReducer(smcs, 'ADD_STRATEGIC_GOAL_MILESTONE_COMMENT'),
                        entityEditReducer(smcs, 'EDIT_STRATEGIC_GOAL_MILESTONE_COMMENT')
                    ),
                    Metrics: sortedEntitiesReducer(smms, 'Name', switchReducers(smms,
                        entityLoadAllReducer(smms, 'LOAD_STRATEGIC_GOAL_MILESTONE_METRIC_SLICE'),
                        (state, action: Action<'ADD_STRATEGIC_GOAL_MILESTONE_METRIC'>) => {
                            let newState = state || smms;

                            if (action.type === 'ADD_STRATEGIC_GOAL_MILESTONE_METRIC') {
                                const entity = action.payload.status !== RequestStatus.SUCCEEDED ?
                                    deepAssign(action.payload.entity, { Custom: { status: action.payload.status } }) :
                                    deepAssign(action.payload.response, { Custom: { internalID: action.payload.entity.Custom.internalID } });

                                let entityIndex = newState.Data.getIndexByID(entity.ID);

                                if (entityIndex < 0) {
                                    entityIndex = newState.Data.length;
                                    newState = deepAssign(newState, {
                                        Count: newState.Count + 1,
                                        TotalCount: newState.TotalCount + 1
                                    });
                                }

                                newState = deepAssign(newState, { Data: { [entityIndex]: entity } });
                            }

                            return newState;
                        },
                        entityLoadReducer(smms, 'LOAD_STRATEGIC_GOAL_MILESTONE_METRIC'),
                        entityEditReducer(smms, 'EDIT_STRATEGIC_GOAL_MILESTONE_METRIC'),
                        entityDeleteReducer(smms, 'DELETE_STRATEGIC_GOAL_MILESTONE_METRIC')
                    )),
                    StatusUpdates: switchReducers(smus,
                        entityLoadAllReducer(smus, 'LOAD_STRATEGIC_GOAL_MILESTONE_STATUS_UPDATE_SLICE'),
                        entityAddReducer(smus, 'ADD_STRATEGIC_GOAL_MILESTONE_STATUS_UPDATE'),
                        entityEditReducer(smus, 'EDIT_STRATEGIC_GOAL_MILESTONE_STATUS_UPDATE'),
                        entityDeleteReducer(smus, 'DELETE_STRATEGIC_GOAL_MILESTONE_STATUS_UPDATE')
                    ),
                    SecondaryStatusUpdates: switchReducers(smsus,
                        entityLoadAllReducer(smsus, 'LOAD_STRATEGIC_GOAL_MILESTONE_SECONDARY_STATUS_UPDATE_SLICE'),
                        entityAddReducer(smsus, 'ADD_STRATEGIC_GOAL_MILESTONE_SECONDARY_STATUS_UPDATE')
                    ),
                    CustomFieldLinks: switchReducers(secfl,
                        entityAddAllReducer(secfl, 'ADD_ALL_STRATEGIC_PROGRAM_CUSTOM_FIELD_LINKS'),
                        entityEditAllReducer(secfl, 'EDIT_ALL_STRATEGIC_PROGRAM_CUSTOM_FIELD_LINKS'),
                        entityDeleteAllReducer(secfl, 'DELETE_ALL_STRATEGIC_PROGRAM_CUSTOM_FIELD_LINKS')
                    ),
                    CustomEntityData: switchReducers(seceds,
                        entityAddAllReducer(seceds, 'ADD_ALL_STRATEGIC_GOAL_MILESTONE_CUSTOM_ENTITY_DATA'),
                        entityAddReducer(seceds, 'ADD_STRATEGIC_GOAL_MILESTONE_CUSTOM_ENTITY_DATA'),
                        entityEditAllReducer(seceds, 'EDIT_ALL_STRATEGIC_GOAL_MILESTONE_CUSTOM_ENTITY_DATA'),
                        entityEditReducer(seceds, 'EDIT_STRATEGIC_GOAL_MILESTONE_CUSTOM_ENTITY_DATA'),
                        entityDeleteAllReducer(seceds, 'DELETE_ALL_STRATEGIC_GOAL_MILESTONE_CUSTOM_ENTITY_DATA'),
                        entityDeleteReducer(seceds, 'DELETE_STRATEGIC_GOAL_MILESTONE_CUSTOM_ENTITY_DATA')
                    ),
                    TeamLinks: switchReducers(smtl,
                        entityAddAllReducer(smtl, 'ADD_ALL_STRATEGIC_GOAL_MILESTONE_TEAM_LINKS'),
                        entityDeleteAllReducer(smtl, 'DELETE_ALL_STRATEGIC_GOAL_MILESTONE_TEAM_LINKS')
                    ),
                    SecondaryOwners: switchReducers(smsos,
                        entityAddAllReducer(smsos, 'ADD_ALL_STRATEGIC_GOAL_MILESTONE_SECONDARY_OWNERS'),
                        entityDeleteAllReducer(smsos, 'DELETE_ALL_STRATEGIC_GOAL_MILESTONE_SECONDARY_OWNERS')
                    )
                }),
                (state, action) => state.Data.getIndexByID(action.payload && ((action.payload as any).grandParentID || (action.payload as any).parentID))
            ),
            (state, action) => {
                let newState = state || sms;

                if (action.type === ActionType.EDIT_GENERAL_SETTINGS_SUCCESS) {
                    return deepAssign(newState, { Custom: { expires: new Date() } });
                }

                if (action.type === 'DELETE_STRATEGY_EXECUTION_CUSTOM_FIELD' ||
                    action.type === 'DELETE_ALL_STRATEGY_EXECUTION_CUSTOM_FIELDS' ||
                    action.type === 'DELETE_ALL_STRATEGY_EXECUTION_CUSTOM_FIELD_OPTIONS' ||
                    action.type === 'SET_STRATEGY_DESCRIPTION_STATUS' ||
                    action.type === 'COMPLETE_STRATEGIC_GOAL_MILESTONE' && action.payload.status === RequestStatus.SUCCEEDED ||
                    action.type === 'ARCHIVE_STRATEGIC_GOAL_MILESTONE' && action.payload.status === RequestStatus.SUCCEEDED ||
                    action.type === 'EDIT_AND_CLOSE_STRATEGIC_PROGRAM' && action.payload.status === RequestStatus.SUCCEEDED) {
                    return deepAssign(newState, { Custom: { status: RequestStatus.UNSYNCED } });
                }

                if (action.type === 'EDIT_STRATEGIC_GOAL_MILESTONE' && action.payload.status === RequestStatus.SUCCEEDED) {
                    return deepAssign(newState, {
                        Data: {
                            [newState.Data.getIndexByID(action.payload.entity.ID)]: {
                                Metrics: {
                                    Custom: {
                                        status: RequestStatus.UNSYNCED
                                    }
                                }
                            }
                        }
                    });
                }

                if (action.type === 'EDIT_STRATEGIC_GOAL_MILESTONE_AND_UPDATE_PROGRESS' && action.payload.status === RequestStatus.SUCCEEDED) {
                    return deepAssign(newState, {
                        Data: {
                            [newState.Data.getIndexByID(action.payload.entity.ID)]: {
                                ...action.payload.entity,
                                SuccessCalculationCurrentPercentage: action.payload.response.SuccessCalculationCurrentPercentage,
                                SuccessCalculationStatusUpdateID: action.payload.response.SuccessCalculationStatusUpdateID,
                                StatusUpdates: action.payload.response.StatusUpdates,
                                Updated: action.payload.response.Updated,
                                UpdatedBy: action.payload.response.UpdatedBy,
                                Expired: action.payload.response.Expired
                            }
                        }
                    });
                }

                if (action.type === 'DELETE_STRATEGIC_GOAL_MILESTONE' && action.payload.status === RequestStatus.SUCCEEDED) {
                    return deepAssign(newState, {
                        Data: newState.Data.map(({ ConnectedToMilestoneID }) => ({
                            ConnectedToMilestoneID: action.payload.entityID !== ConnectedToMilestoneID ? ConnectedToMilestoneID : null
                        }))
                    });
                }

                if (action.type === 'DELETE_STRATEGIC_PROGRAM' && action.payload.status === RequestStatus.SUCCEEDED) {
                    return deepAssign(newState, {
                        Data: newState.Data.map(({ ConnectedToProgramID }) => ({
                            ConnectedToProgramID: action.payload.entityID !== ConnectedToProgramID ? ConnectedToProgramID : null
                        }))
                    });
                }

                if (action.type === 'ADD_STRATEGIC_GOAL_MILESTONE_STATUS_UPDATE' && action.payload.status === RequestStatus.SUCCEEDED ||
                    action.type === 'ADD_STRATEGIC_GOAL_MILESTONE_SECONDARY_STATUS_UPDATE' && action.payload.status === RequestStatus.SUCCEEDED) {
                    const milestone = newState.Data.getByID(action.payload.parentID);

                    if (milestone) {
                        let change: Partial<entities.StrategicGoalMilestoneReport> = {
                            Expired: milestone.Expired && +new Period(PeriodType.MONTH, action.payload.entity.UpdateDate) !== +ACTIVE_MILESTONE_PERIOD
                        };

                        const
                            reloadStatusUpdates = milestone.SecondaryStatusUpdateTypeID === StrategyExecutionSecondaryStatusUpdateType.NORMAL_STATUS_UPDATE ||
                                milestone.SecondaryStatusUpdateTypeID === StrategyExecutionSecondaryStatusUpdateType.COMMUNITY_AVERAGE,
                            updateSuccessCalculation = milestone.StatusID !== StrategicGoalMilestoneStatus.DRAFT && (
                                action.type === 'ADD_STRATEGIC_GOAL_MILESTONE_STATUS_UPDATE' ||
                                action.type === 'ADD_STRATEGIC_GOAL_MILESTONE_SECONDARY_STATUS_UPDATE' && reloadStatusUpdates
                            );

                        if (updateSuccessCalculation) {
                            let successCalculationID: StrategicGoalMilestoneFinalStatus | null = null;

                            switch (action.payload.entity.AchievabilityID) {
                                case StrategicGoalMilestoneAchievability.VERY_LOW:
                                    successCalculationID = StrategicGoalMilestoneFinalStatus.VERY_LOW;
                                    break;

                                case StrategicGoalMilestoneAchievability.LOW:
                                    successCalculationID = StrategicGoalMilestoneFinalStatus.LOW;
                                    break;

                                case StrategicGoalMilestoneAchievability.MEDIUM:
                                    successCalculationID = StrategicGoalMilestoneFinalStatus.AVERAGE;
                                    break;

                                case StrategicGoalMilestoneAchievability.HIGH:
                                    successCalculationID = StrategicGoalMilestoneFinalStatus.HIGH;
                                    break;

                                case StrategicGoalMilestoneAchievability.VERY_HIGH:
                                    successCalculationID = StrategicGoalMilestoneFinalStatus.VERY_HIGH;
                                    break;

                                default:
                                    successCalculationID = null;
                                    break;
                            }

                            change = deepAssign(change, {
                                AchievabilityID: action.payload.entity.AchievabilityID,
                                SuccessCalculationCurrentPercentage: null,
                                SuccessCalculationStatusUpdateID: successCalculationID!
                            });
                        }

                        if (reloadStatusUpdates) {
                            change = deepAssign(change, {
                                StatusUpdates: {
                                    Custom: {
                                        status: RequestStatus.UNSYNCED
                                    }
                                }
                            });
                        }

                        return deepAssign(newState, {
                            Data: {
                                [newState.Data.getIndexByID(action.payload.parentID)]: change
                            }
                        });
                    }
                }

                if (action.type === 'PUBLISH_STRATEGIC_GOAL_MILESTONE' || action.type === 'ARCHIVE_STRATEGIC_GOAL_MILESTONE') {
                    return action.payload.status !== RequestStatus.SUCCEEDED ?
                        entityEditReducer(newState, action.type)(newState, action) :
                        entityLoadReducer(newState, action.type)(newState, action);
                }

                if (action.type === 'LOAD_MANY_STRATEGIC_GOAL_MILESTONES') {
                    for (let entityIndex = 0; entityIndex < action.payload.entityIDs.length; entityIndex++) {
                        const
                            entityID = action.payload.entityIDs[entityIndex],
                            oldEntity = newState.Data.getByID(entityID);

                        let
                            position = newState.Data.getIndexByID(entityID),
                            change = {
                                Custom: { status: action.payload.status }
                            };

                        if (action.payload.status === RequestStatus.SUCCEEDED) {
                            change = action.payload.response.getByID(entityID);

                            if (position < 0) {
                                position = newState.Data.length;
                            }
                            else if (oldEntity) {
                                if (!action.payload.maxMetricsCount) {
                                    change = deepAssign(change as unknown as entities.StrategicGoalMilestoneReport, {
                                        Metrics: { ...oldEntity.Metrics }
                                    });
                                }

                                if (!action.payload.maxStatusUpdatesCount) {
                                    change = deepAssign(change as unknown as entities.StrategicGoalMilestoneReport, {
                                        StatusUpdates: { ...oldEntity.StatusUpdates }
                                    });
                                }

                                if (!action.payload.maxCommentsCount) {
                                    change = deepAssign(change as unknown as entities.StrategicGoalMilestoneReport, {
                                        Comments: { ...oldEntity.Comments }
                                    });
                                }
                            }
                        }

                        newState = deepAssign(newState, {
                            Data: {
                                [position]: change
                            }
                        });
                    }

                    return newState;
                }

                let paginationSlicePropertyName = '';

                switch (action.type) {
                    case 'SEARCH_STRATEGIC_GOAL_MILESTONE_COMMENTS':
                        paginationSlicePropertyName = 'Comments';
                        break;

                    case 'SEARCH_STRATEGIC_GOAL_MILESTONE_METRICS':
                        paginationSlicePropertyName = 'Metrics';
                        break;

                    case 'SEARCH_STRATEGIC_GOAL_MILESTONE_STATUS_UPDATES':
                        paginationSlicePropertyName = 'StatusUpdates';
                        break;

                    default:
                        break;
                }

                if (paginationSlicePropertyName) {
                    return deepAssign(newState, {
                        Data: newState.Data.map((milestone) => {
                            if (!action.payload.parentIDs.includes(milestone.ID)) { return milestone; }

                            let change: Partial<entities.StrategicGoalMilestoneReport> = {
                                [paginationSlicePropertyName]: {
                                    Custom: {
                                        status: action.payload.status as RequestStatus
                                    }
                                }
                            };

                            if (action.payload.status === RequestStatus.SUCCEEDED) {
                                const items = (action.payload.response as unknown as any[]).filter(({ MilestoneID }) => MilestoneID === milestone.ID);
                                change = deepAssign(change, {
                                    [paginationSlicePropertyName]: {
                                        TotalCount: items.length,
                                        Count: items.length,
                                        NextID: 0,
                                        Data: items
                                    }
                                });
                            }

                            return change;
                        })
                    });
                }

                if (action.type === 'VOID_ALL_STRATEGIC_GOAL_MILESTONE_SECONDARY_STATUS_UPDATES') {
                    return deepAssign(newState, {
                        Data: newState.Data.map((milestone) => {
                            if (!!action.payload.parentID && milestone.ID !== action.payload.parentID) { return milestone; }

                            return {
                                SecondaryStatusUpdates: {
                                    Custom: {
                                        status: RequestStatus.UNSYNCED
                                    }
                                }
                            };
                        })
                    });
                }

                if (action.type === 'DELETE_STRATEGIC_GOAL') {
                    return deepAssign(newState, { Data: newState.Data.filter(({ GoalID }) => GoalID !== action.payload.entityID) });
                }

                if ((action.type === 'COPY_STRATEGY_DESCRIPTION' || action.type === 'PUBLISH_STRATEGY_DESCRIPTION' || action.type === 'AUTOMATICALLY_PUBLISH_STRATEGY') &&
                    action.payload.status === RequestStatus.SUCCEEDED) {
                    return deepAssign(newState, { Custom: { status: RequestStatus.UNSYNCED } });
                }

                if (action.type === 'EDIT_PERFORMANCE_INDICATOR_SUCCESS') {
                    return deepAssign(newState, {
                        Data: newState.Data.map(({ Metrics }) => ({
                            Metrics: {
                                Data: Metrics.Data.map(metric => ({
                                    PerformancePerspectiveGroupID: metric.IndicatorID !== (action as any).indicatorID ?
                                        metric.PerformancePerspectiveGroupID :
                                        (action.indicator as entities.PerformanceIndicatorReport).PerformancePerspectiveGroupID
                                }))
                            }
                        }))
                    });
                }

                if (action.type === ActionType.MERGE_ALL_PERFORMANCE_INDICATOR_DAY_DATA_SUCCESS ||
                    action.type === ActionType.MERGE_ALL_PERFORMANCE_INDICATOR_WEEK_DATA_SUCCESS ||
                    action.type === ActionType.MERGE_ALL_PERFORMANCE_INDICATOR_MONTH_DATA_SUCCESS ||
                    action.type === ActionType.MERGE_ALL_PERFORMANCE_INDICATOR_QUARTER_DATA_SUCCESS ||
                    action.type === ActionType.MERGE_ALL_PERFORMANCE_INDICATOR_YEAR_DATA_SUCCESS) {
                    const
                        corporateStructureLink = defaults.CorporateStructureLink,
                        corporateStructureProperties = Object.keys(corporateStructureLink).filter(key =>
                            Object.prototype.hasOwnProperty.call(corporateStructureLink, key) && key !== 'Custom'
                        );

                    return deepAssign(newState, {
                        Data: newState.Data.map(({ Metrics }) => ({
                            Metrics: {
                                Data: Metrics.Data.map(metric => ({
                                    Expired: metric.Expired ?
                                        !(action as any).entities.some((entity: entities.PerformanceIndicatorDataBase) =>
                                            entity.PeriodTypeID === metric.PeriodTypeID &&
                                            entity.KeyPerformanceIndicatorID === metric.IndicatorID &&
                                            entity.CorporateStructureLink && corporateStructureProperties.every(property =>
                                                (entity.CorporateStructureLink as any)[property] === (metric.CorporateStructureLink as any)[property]
                                            ) &&
                                            entity.ActualSourceID === PerformanceIndicatorValueSource.MANUAL &&
                                            +entity.Date === +new Period(metric.PeriodTypeID).previous.start
                                        ) :
                                        false
                                }))
                            }
                        }))
                    });
                }

                const
                    clearMilestoneConnections: number[] = [],
                    clearProgramConnections: number[] = [];

                if ((action as any)?.payload?.status === RequestStatus.SUCCEEDED) {
                    if (action.type === 'EDIT_ALL_STRATEGIC_GOAL_MILESTONES') {
                        clearMilestoneConnections.push(...(action.payload.entities as entities.StrategicGoalMilestoneReport[])
                            .filter(({ ProgressCalculationSourceID }) => ProgressCalculationSourceID !== StrategyProgressCalculationSource.CONNECTED_ITEMS)
                            .map(({ ID }) => ID));
                    }

                    if ((action.type === 'EDIT_STRATEGIC_GOAL_MILESTONE' || action.type === 'EDIT_STRATEGIC_GOAL_MILESTONE_AND_UPDATE_PROGRESS') &&
                        action.payload.entity.ProgressCalculationSourceID !== StrategyProgressCalculationSource.CONNECTED_ITEMS) {
                        clearMilestoneConnections.push(action.payload.entityID);
                    }

                    if (action.type === 'EDIT_ALL_STRATEGIC_PROGRAMS') {
                        clearProgramConnections.push(...(action.payload.entities as entities.StrategicProgramReport[])
                            .filter(({ ProgressCalculationSourceID }) => ProgressCalculationSourceID !== StrategyProgressCalculationSource.CONNECTED_ITEMS)
                            .map(({ ID }) => ID));
                    }

                    if ((action.type === 'EDIT_STRATEGIC_PROGRAM' || action.type === 'EDIT_AND_CLOSE_STRATEGIC_PROGRAM') &&
                        action.payload.entity.ProgressCalculationSourceID !== StrategyProgressCalculationSource.CONNECTED_ITEMS) {
                        clearProgramConnections.push(action.payload.entityID);
                    }
                }

                if (clearMilestoneConnections.length || clearProgramConnections) {
                    return deepAssign(newState, {
                        Data: newState.Data.map(({ ConnectedToMilestoneID, ConnectedToProgramID }) => ({
                            ConnectedToMilestoneID: clearMilestoneConnections.includes(ConnectedToMilestoneID!) ? null : ConnectedToMilestoneID,
                            ConnectedToProgramID: clearProgramConnections.includes(ConnectedToProgramID!) ? null : ConnectedToProgramID
                        }))
                    });
                }

                return newState;
            },
            entityVoidAllReducer(sms, 'VOID_ALL_STRATEGIC_GOAL_MILESTONES')
        )),
        goalMetricValueSources: synchronizableEnumReducer(
            defaults.NetworkArrayOf(defaults.GoalMetricValueSource),
            'LOAD_ALL_GOAL_METRIC_VALUE_SOURCES',
            GoalMetricValueSource as any,
            'GoalMetricValueSource'
        ),
        goalMetricValueTypes: synchronizableEnumReducer(
            defaults.NetworkArrayOf(defaults.GoalMetricValueType),
            'LOAD_ALL_GOAL_METRIC_VALUE_TYPES',
            GoalMetricValueType as any,
            'GoalMetricValueType'
        ),
        strategyProgressCalculationMethods: synchronizableEnumReducer(
            defaults.NetworkArrayOf(defaults.StrategyProgressCalculationMethod),
            'LOAD_ALL_STRATEGY_PROGRESS_CALCULATION_METHODS',
            StrategyProgressCalculationMethod as any,
            'StrategyProgressCalculationMethod'
        ),
        strategyProgressCalculationSources: synchronizableEnumReducer(
            defaults.NetworkArrayOf(defaults.StrategyProgressCalculationSource),
            'LOAD_ALL_STRATEGY_PROGRESS_CALCULATION_SOURCES',
            StrategyProgressCalculationSource as any,
            'StrategyProgressCalculationSource'
        ),
        strategyExecutionSecondaryStatusUpdateTypes: synchronizableEnumReducer(
            defaults.NetworkArrayOf(defaults.StrategyExecutionSecondaryStatusUpdateType),
            'LOAD_ALL_STRATEGY_EXECUTION_SECONDARY_STATUS_UPDATE_TYPES',
            StrategyExecutionSecondaryStatusUpdateType as any,
            'StrategyExecutionSecondaryStatusUpdateType'
        ),
        strategicGoalMilestoneAchievabilities: synchronizableEnumReducer(
            gma,
            'LOAD_ALL_STRATEGIC_GOAL_MILESTONE_ACHIEVABILITIES',
            StrategicGoalMilestoneAchievability as any,
            'StrategicGoalMilestoneAchievability'
        ),
        strategicGoalMilestoneStatuses: synchronizableEnumReducer(
            gms,
            'LOAD_ALL_STRATEGIC_GOAL_MILESTONE_STATUSES',
            StrategicGoalMilestoneStatus as any,
            'StrategicGoalMilestoneStatus'
        ),
        strategicGoalMilestoneFinalStatuses: synchronizableEnumReducer(
            gmfs,
            'LOAD_ALL_STRATEGIC_GOAL_MILESTONE_FINAL_STATUSES',
            StrategicGoalMilestoneFinalStatus as any,
            'StrategicGoalMilestoneFinalStatus'
        ),
        strategicPrograms: sortedEntitiesReducer(sps, 'Name', switchReducers(sps,
            (state, action) => {
                let nextState = state || sps;

                if (action.type === 'LOAD_ALL_STRATEGIC_PROGRAMS') {
                    return entityLoadAllReducer(sps, 'LOAD_ALL_STRATEGIC_PROGRAMS')(nextState, action);
                }

                if (action.type === 'LOAD_ALL_STRATEGIC_PROGRAMS_QUIETLY' &&
                    (action.payload.status === RequestStatus.SUCCEEDED || action.payload.status === RequestStatus.FAILED)) {
                    return entityLoadAllReducer(sps, 'LOAD_ALL_STRATEGIC_PROGRAMS_QUIETLY')(nextState, action);
                }

                if (action.type === 'LOAD_MANY_STRATEGIC_PROGRAMS') {
                    for (let entityIndex = 0; entityIndex < action.payload.entityIDs.length; entityIndex++) {
                        const
                            entityID = action.payload.entityIDs[entityIndex],
                            oldEntity = nextState.Data.getByID(entityID);

                        let
                            position = nextState.Data.getIndexByID(entityID),
                            change = {
                                Custom: { status: action.payload.status }
                            };

                        if (action.payload.status === RequestStatus.SUCCEEDED) {
                            change = action.payload.response.getByID(entityID);

                            if (position < 0) {
                                position = nextState.Data.length;
                            }
                            else if (oldEntity) {
                                if (!action.payload.maxStatusUpdatesCount) {
                                    change = deepAssign(change as unknown as entities.StrategicProgramReport, {
                                        StatusUpdates: { ...oldEntity.StatusUpdates }
                                    });
                                }

                                if (!action.payload.maxCommentsCount) {
                                    change = deepAssign(change as unknown as entities.StrategicProgramReport, {
                                        Comments: { ...oldEntity.Comments }
                                    });
                                }
                            }
                        }

                        nextState = deepAssign(nextState, {
                            Data: {
                                [position]: change
                            }
                        });
                    }

                    return nextState;
                }

                return nextState;
            },
            entityAddAllReducer(sps, 'ADD_ALL_STRATEGIC_PROGRAMS'),
            entityEditAllReducer(sps, 'EDIT_ALL_STRATEGIC_PROGRAMS'),
            entityLoadReducer(sps, 'LOAD_STRATEGIC_PROGRAM'),
            entityAddReducer(sps, 'ADD_STRATEGIC_PROGRAM'),
            entityEditReducer(sps, 'EDIT_STRATEGIC_PROGRAM'),
            childrenReducer(sps,
                combineReducers(defaults.StrategicProgramReport, {
                    Comments: switchReducers(spcs,
                        entityLoadAllReducer(spcs, 'LOAD_STRATEGIC_PROGRAM_COMMENTS_SLICE'),
                        entityAddReducer(spcs, 'ADD_STRATEGIC_PROGRAM_COMMENT'),
                        entityEditReducer(spcs, 'EDIT_STRATEGIC_PROGRAM_COMMENT')
                    ),
                    Metric: // TODO Alter the base reducers to work with nullable entities
                        (state, action: Action<'LOAD_STRATEGIC_PROGRAM_METRIC' | 'ADD_STRATEGIC_PROGRAM_METRIC' | 'EDIT_STRATEGIC_PROGRAM_METRIC' | 'DELETE_STRATEGIC_PROGRAM_METRIC'>) => {
                            switch (action.type) {
                                case 'LOAD_STRATEGIC_PROGRAM_METRIC':
                                    return state ?
                                        entityLoadReducer(gm, 'LOAD_STRATEGIC_PROGRAM_METRIC')(state, action) :
                                        action.payload.status === RequestStatus.SUCCEEDED ?
                                            action.payload.response :
                                            gmn;

                                case 'ADD_STRATEGIC_PROGRAM_METRIC':
                                    if (action.payload.status === RequestStatus.SUCCEEDED) {
                                        return action.payload.response;
                                    }
                                    else {
                                        return entityAddReducer(gm, 'ADD_STRATEGIC_PROGRAM_METRIC')(state || action.payload.entity, action);
                                    }

                                case 'EDIT_STRATEGIC_PROGRAM_METRIC':
                                    return entityEditReducer(gm, 'EDIT_STRATEGIC_PROGRAM_METRIC')(state || action.payload.entity, action);

                                case 'DELETE_STRATEGIC_PROGRAM_METRIC':
                                    return state ? entityDeleteReducer(gm, 'DELETE_STRATEGIC_PROGRAM_METRIC')(state, action) : state;

                                default:
                                    return state || gmn;
                            }
                        },
                    StatusUpdates: switchReducers(spus,
                        entityLoadAllReducer(spus, 'LOAD_STRATEGIC_PROGRAM_STATUS_UPDATES_SLICE'),
                        entityAddReducer(spus, 'ADD_STRATEGIC_PROGRAM_STATUS_UPDATE'),
                        entityEditReducer(spus, 'EDIT_STRATEGIC_PROGRAM_STATUS_UPDATE'),
                        entityDeleteReducer(spus, 'DELETE_STRATEGIC_PROGRAM_STATUS_UPDATE'),
                        childrenReducer(spus,
                            combineReducers(defaults.StrategicProgramStatusUpdateReport, {
                                NotificationRecipients: switchReducers(spurs,
                                    entityLoadAllReducer(spurs, 'LOAD_STRATEGIC_PROGRAM_STATUS_UPDATE_RECIPIENTS_SLICE'),
                                    entityAddAllReducer(spurs, 'ADD_ALL_STRATEGIC_PROGRAM_STATUS_UPDATE_RECIPIENTS')
                                )
                            }),
                            (state, action) => state.Data.getIndexByID(action.payload && (action.payload as any).parentID)
                        ),
                        (state, action) => {
                            const nextState = state || spus;

                            if (action.type === 'ADD_STRATEGIC_PROGRAM_STATUS_UPDATE' && action.payload.status === RequestStatus.SUCCEEDED) {
                                return deepAssign(nextState, { Custom: { status: RequestStatus.UNSYNCED } });
                            }

                            return nextState;
                        }
                    ),
                    CustomFieldLinks: switchReducers(secfl,
                        entityAddAllReducer(secfl, 'ADD_ALL_STRATEGIC_PROGRAM_CUSTOM_FIELD_LINKS'),
                        entityEditAllReducer(secfl, 'EDIT_ALL_STRATEGIC_PROGRAM_CUSTOM_FIELD_LINKS'),
                        entityDeleteAllReducer(secfl, 'DELETE_ALL_STRATEGIC_PROGRAM_CUSTOM_FIELD_LINKS')
                    ),
                    SecondaryOwners: switchReducers(spsos,
                        entityAddAllReducer(spsos, 'ADD_ALL_STRATEGIC_PROGRAM_SECONDARY_OWNERS'),
                        entityDeleteAllReducer(spsos, 'DELETE_ALL_STRATEGIC_PROGRAM_SECONDARY_OWNERS')
                    )
                }),
                (state, action) => state.Data.getIndexByID(action.payload && ((action.payload as any).grandParentID || (action.payload as any).parentID))
            ),
            entityDeleteReducer(sps, 'DELETE_STRATEGIC_PROGRAM'),
            (state, action) => {
                const newState = state || sps;

                if (action.type === ActionType.EDIT_GENERAL_SETTINGS_SUCCESS) {
                    return deepAssign(newState, { Custom: { expires: new Date() } });
                }

                if (action.type === 'EDIT_PERFORMANCE_INDICATOR_SUCCESS' ||
                    action.type === 'COPY_STRATEGY_DESCRIPTION' && action.payload.status === RequestStatus.SUCCEEDED ||
                    action.type === 'PUBLISH_STRATEGY_DESCRIPTION' && action.payload.status === RequestStatus.SUCCEEDED ||
                    action.type === 'AUTOMATICALLY_PUBLISH_STRATEGY' && action.payload.status === RequestStatus.SUCCEEDED ||
                    action.type === 'DELETE_STRATEGY_DESCRIPTION' && action.payload.status === RequestStatus.SUCCEEDED ||
                    action.type === 'SET_STRATEGY_DESCRIPTION_STATUS' && action.payload.status === RequestStatus.SUCCEEDED ||
                    action.type === 'COMPLETE_STRATEGIC_GOAL_MILESTONE' && action.payload.status === RequestStatus.SUCCEEDED ||
                    action.type === 'ADD_ALL_STRATEGIC_PROGRAMS' && action.payload.status === RequestStatus.SUCCEEDED && action.payload.reload ||
                    action.type === 'EDIT_MEETING_STATUS_SUCCESS' && action.statusID === MeetingStatus.ARCHIVED ||
                    action.type === 'DELETE_STRATEGY_EXECUTION_CUSTOM_FIELD' ||
                    action.type === 'DELETE_ALL_STRATEGY_EXECUTION_CUSTOM_FIELDS_SUCCESS' ||
                    action.type === 'DELETE_ALL_STRATEGY_EXECUTION_CUSTOM_FIELD_OPTIONS_SUCCESS' ||
                    action.type === 'ARCHIVE_STRATEGIC_GOAL_MILESTONE' && action.payload.status === RequestStatus.SUCCEEDED ||
                    action.type === 'EDIT_AND_CLOSE_STRATEGIC_PROGRAM' && action.payload.status === RequestStatus.SUCCEEDED) {
                    return deepAssign(newState, { Custom: { status: RequestStatus.UNSYNCED } });
                }

                if (action.type === 'VOID_ALL_STRATEGY_DESCRIPTIONS') {
                    return entityVoidAllReducer(sps, action.type)(state, action);
                }

                if (action.type === 'DELETE_STRATEGIC_GOAL_MILESTONE' && action.payload.status === RequestStatus.SUCCEEDED) {
                    return deepAssign(newState, {
                        Data: newState.Data.map(({ ConnectedToMilestoneID }) => ({
                            ConnectedToMilestoneID: action.payload.entityID !== ConnectedToMilestoneID ? ConnectedToMilestoneID : null
                        }))
                    });
                }

                if (action.type === 'SEARCH_STRATEGIC_PROGRAM_STATUS_UPDATES') {
                    return deepAssign(newState, {
                        Data: newState.Data.map((program) => {
                            if (!action.payload.parentIDs.includes(program.ID)) { return program; }

                            let change: any = {
                                StatusUpdates: {
                                    Custom: {
                                        status: action.payload.status as RequestStatus
                                    }
                                }
                            };

                            if (action.payload.status === RequestStatus.SUCCEEDED) {
                                const items = (action.payload.response as unknown as any[]).filter(({ ProgramID }) => ProgramID === program.ID);
                                change = deepAssign(change, {
                                    StatusUpdates: {
                                        TotalCount: items.length,
                                        Count: items.length,
                                        NextID: 0,
                                        Data: items
                                    }
                                });
                            }

                            return change;
                        })
                    });
                }

                if (action.type === 'ADD_STRATEGIC_PROGRAM' && action.payload.status === RequestStatus.SUCCEEDED && action.payload.response) {
                    const newData = newState.Data.copy();

                    newData.push({
                        ...action.payload.entity,
                        ID: action.payload.response
                    });

                    return deepAssign(newState, { Data: newData });
                }

                const
                    clearMilestoneConnections: number[] = [],
                    clearProgramConnections: number[] = [];

                if ((action as any)?.payload?.status === RequestStatus.SUCCEEDED) {
                    if (action.type === 'EDIT_ALL_STRATEGIC_GOAL_MILESTONES') {
                        clearMilestoneConnections.push(...(action.payload.entities as entities.StrategicGoalMilestoneReport[])
                            .filter(({ ProgressCalculationSourceID }) => ProgressCalculationSourceID !== StrategyProgressCalculationSource.CONNECTED_ITEMS)
                            .map(({ ID }) => ID));
                    }

                    if ((action.type === 'EDIT_STRATEGIC_GOAL_MILESTONE' || action.type === 'EDIT_STRATEGIC_GOAL_MILESTONE_AND_UPDATE_PROGRESS') &&
                        action.payload.entity.ProgressCalculationSourceID !== StrategyProgressCalculationSource.CONNECTED_ITEMS) {
                        clearMilestoneConnections.push(action.payload.entityID);
                    }

                    if (action.type === 'EDIT_ALL_STRATEGIC_PROGRAMS') {
                        clearProgramConnections.push(...(action.payload.entities as entities.StrategicProgramReport[])
                            .filter(({ ProgressCalculationSourceID }) => ProgressCalculationSourceID !== StrategyProgressCalculationSource.CONNECTED_ITEMS)
                            .map(({ ID }) => ID));
                    }

                    if ((action.type === 'EDIT_STRATEGIC_PROGRAM' || action.type === 'EDIT_AND_CLOSE_STRATEGIC_PROGRAM') &&
                        action.payload.entity.ProgressCalculationSourceID !== StrategyProgressCalculationSource.CONNECTED_ITEMS) {
                        clearProgramConnections.push(action.payload.entityID);
                    }
                }

                if (clearMilestoneConnections.length || clearProgramConnections) {
                    return deepAssign(newState, {
                        Data: newState.Data.map(({ ConnectedToMilestoneID, ConnectedToProgramID }) => ({
                            ConnectedToMilestoneID: clearMilestoneConnections.includes(ConnectedToMilestoneID!) ? null : ConnectedToMilestoneID,
                            ConnectedToProgramID: clearProgramConnections.includes(ConnectedToProgramID!) ? null : ConnectedToProgramID
                        }))
                    });
                }

                if (action.type === 'DELETE_STRATEGIC_PROGRAM' && action.payload.status === RequestStatus.SUCCEEDED) {
                    return deepAssign(newState, {
                        Data: newState.Data.map(({ ConnectedToProgramID }) => ({
                            ConnectedToProgramID: action.payload.entityID !== ConnectedToProgramID ? ConnectedToProgramID : null
                        }))
                    });
                }

                if (action.type === 'ADD_STRATEGIC_PROGRAM_METRIC' && action.payload.status === RequestStatus.PENDING) {
                    const program = newState.Data.getByID(action.payload.parentID)!;

                    return deepAssign(newState, {
                        Data: {
                            [newState.Data.getIndexByID(action.payload.parentID)]: {
                                Custom: {
                                    ...program.Custom,
                                    isMetricSaving: true
                                }
                            }
                        }
                    });
                }

                if (action.type === 'ADD_STRATEGIC_PROGRAM_METRIC' && action.payload.status === RequestStatus.SUCCEEDED) {
                    const program = newState.Data.getByID(action.payload.parentID)!;

                    return deepAssign(newState, {
                        Data: {
                            [newState.Data.getIndexByID(action.payload.parentID)]: {
                                Custom: {
                                    ...program.Custom,
                                    isMetricSaving: false
                                }
                            }
                        }
                    });
                }

                return newState;
            },
            entityVoidAllReducer(sps, 'VOID_ALL_STRATEGIC_PROGRAMS')
        )),
        strategicProgramRiskLevels: synchronizableEnumReducer(sprs, 'LOAD_ALL_STRATEGIC_PROGRAM_RISK_LEVELS', StrategicProgramRiskLevel as any, 'StrategicProgramRiskLevel'),
        strategicProgramStatuses: synchronizableEnumReducer(spss, 'LOAD_ALL_STRATEGIC_PROGRAM_STATUSES', StrategicProgramStatus as any, 'StrategicProgramStatus'),
        strategicProgramFinalStatuses: synchronizableEnumReducer(spfs, 'LOAD_ALL_STRATEGIC_PROGRAM_FINAL_STATUSES', StrategicProgramFinalStatus as any, 'StrategicProgramFinalStatus'),
        strategicProgramUpdateFrequencies: synchronizableEnumReducer(
            spufs,
            'LOAD_ALL_STRATEGIC_PROGRAM_UPDATE_FREQUENCIES',
            StrategicProgramUpdateFrequency as any,
            'StrategicProgramUpdateFrequency'
        ),
        strategyPublishingLevels: synchronizableEnumReducer(spl, 'LOAD_ALL_STRATEGY_PUBLISHING_LEVELS', StrategyPublishingLevel as any, 'StrategyPublishingLevel'),
        strategyExecutionTypes: synchronizableEnumReducer(set, 'LOAD_ALL_STRATEGY_EXECUTION_TYPES', StrategyExecutionType as any, 'StrategyExecutionType'),
        strategyFreeNodes: sortedEntitiesReducer(sfs, 'Name', switchReducers(sfs,
            entityLoadAllReducer(sfs, 'LOAD_ALL_STRATEGY_FREE_NODES'),
            entityLoadReducer(sfs, 'LOAD_STRATEGY_FREE_NODE'),
            entityAddReducer(sfs, 'ADD_STRATEGY_FREE_NODE'),
            entityEditReducer(sfs, 'EDIT_STRATEGY_FREE_NODE'),
            entityDeleteReducer(sfs, 'DELETE_STRATEGY_FREE_NODE'),
            (state, action) => {
                let newState = state || sfs,
                    removedFreeNodeIDs = [] as number[];

                if (action.payload && action.payload.status === RequestStatus.SUCCEEDED) {
                    if (action.type === 'DELETE_STRATEGY_DESCRIPTION') {
                        removedFreeNodeIDs = newState.Data.filter(({ ParentDescriptionID }) => ParentDescriptionID === action.payload.entityID).map(({ ID }) => ID);
                    }

                    if (action.type === 'DELETE_STRATEGIC_GOAL') {
                        removedFreeNodeIDs = newState.Data.filter(({ ParentGoalID }) => ParentGoalID === action.payload.entityID).map(({ ID }) => ID);
                    }

                    if (action.type === 'DELETE_STRATEGIC_GOAL_MILESTONE') {
                        removedFreeNodeIDs = newState.Data.filter(({ ParentMilestoneID }) => ParentMilestoneID === action.payload.entityID).map(({ ID }) => ID);
                    }

                    if (action.type === 'DELETE_STRATEGIC_PROGRAM') {
                        removedFreeNodeIDs = newState.Data.filter(({ ParentProgramID }) => ParentProgramID === action.payload.entityID).map(({ ID }) => ID);
                    }

                    if (action.type === 'DELETE_STRATEGY_FREENODE') {
                        removedFreeNodeIDs = [action.payload.entityID];
                    }

                    if (removedFreeNodeIDs.length) {
                        for (let idIndex = 0; idIndex < removedFreeNodeIDs.length; idIndex++) {
                            const parentID = removedFreeNodeIDs[idIndex];
                            removedFreeNodeIDs = removedFreeNodeIDs.concat(newState.Data.filter(({ ParentNodeID }) => ParentNodeID === parentID).map(({ ID }) => ID));
                        }

                        newState = deepAssign(newState, { Data: newState.Data.filter(({ ID }) => !removedFreeNodeIDs.includes(ID)) });
                    }
                }

                if (action.type === 'COPY_STRATEGY_DESCRIPTION' && action.payload.status === RequestStatus.SUCCEEDED ||
                    action.type === 'DELETE_STRATEGY_DESCRIPTION' && action.payload.status === RequestStatus.SUCCEEDED) {
                    return deepAssign(newState, { Custom: { status: RequestStatus.UNSYNCED } });
                }

                if (action.type === 'VOID_ALL_STRATEGY_DESCRIPTIONS') {
                    return entityVoidAllReducer(sfs, action.type)(state, action);
                }

                return newState;
            },
            entityVoidAllReducer(sfs, 'VOID_ALL_STRATEGY_FREE_NODES')
        )),
        strategyFilter: (state, action) => {
            let nextState: StrategyFilter = state || DefaultStrategyFilter;

            if (action.type === 'DELETE_STRATEGY_DESCRIPTION' && action.payload.status === RequestStatus.SUCCEEDED) {
                nextState = deepAssign(nextState, {
                    StrategyIDs: nextState.StrategyIDs.filter(strategyID => !action.payload.deleteSubstrategies && strategyID !== action.payload.entityID)
                });
            }

            if (action.type === LOCATION_CHANGE && (action.payload.pathname.startsWith('/strategy/') || action.payload.pathname === '/')) {
                const
                    { pathname, query } = action.payload,
                    filter = deepAssign(nextState, extractStrategyFilterFromQuery(query));

                switch (pathname) {
                    case '/':
                        return deepAssign(nextState, { View: DefaultStrategyFilter.View });

                    case '/strategy/strategy_map':
                        return deepAssign(filter, { View: StrategyView.MAP });

                    case '/strategy/strategy_description':
                        return deepAssign(filter, { View: StrategyView.STRATEGY });

                    case '/strategy/indicators':
                        return deepAssign(filter, { View: StrategyView.INDICATORS });

                    case '/strategy/big_picture':
                        return deepAssign(filter, { View: StrategyView.BIG_PICTURE });

                    default:
                        return nextState;
                }
            }

            if (action.type === 'SET_STRATEGY_FILTER') {
                return action.payload.filter;
            }

            return nextState;
        },
        strategyExecutionFilter: (state, action) => {
            let nextState: StrategyFilter = state || DefaultStrategyFilter;

            if (action.type === 'DELETE_STRATEGY_DESCRIPTION' && action.payload.status === RequestStatus.SUCCEEDED) {
                nextState = deepAssign(nextState, {
                    StrategyIDs: nextState.StrategyIDs.filter(strategyID => !action.payload.deleteSubstrategies && strategyID !== action.payload.entityID)
                });
            }

            if (action.type === LOCATION_CHANGE && (action.payload.pathname.startsWith('/strategy_execution/') || action.payload.pathname === '/')) {
                const
                    { pathname, query } = action.payload,
                    filter = deepAssign(nextState, extractStrategyFilterFromQuery(query));

                switch (pathname) {
                    case '/':
                        return deepAssign(nextState, { View: DefaultStrategyFilter.View });

                    case '/strategy_execution/roadmap':
                        return deepAssign(filter, { View: StrategyView.ROADMAP });

                    case '/strategy_execution/strategy_board':
                        return deepAssign(filter, { View: StrategyView.KANBAN });

                    case '/strategy_execution/organization_structure':
                        return deepAssign(filter, { View: StrategyView.ORGANIZATION_CHART });

                    case '/strategy_execution/execution_review':
                        return deepAssign(filter, { View: StrategyView.BUSINESS_REVIEW });

                    default:
                        return nextState;
                }
            }

            if (action.type === 'SET_STRATEGY_EXECUTION_FILTER') {
                return action.payload.filter;
            }

            return nextState;
        },
        strategyContentSettings: (state, action: Action<'SET_STRATEGY_CONTENT_SETTINGS'>) => {
            const defaultState = state || DefaultStrategyContentSettings;

            if (action.type === 'SET_STRATEGY_CONTENT_SETTINGS' && !action.payload.dashboardPageID && !action.payload.dashboardBlockID) {
                return action.payload.settings;
            }

            return defaultState;
        },
        strategyActionListContentSettings: (state, action: Action<'SET_STRATEGY_ACTION_LIST_CONTENT_SETTINGS'>) => {
            let newState = state || DefaultStrategyActionListContentSettings;

            if (action.type === 'SET_STRATEGY_ACTION_LIST_CONTENT_SETTINGS') {
                newState = deepAssign(action.payload.settings, {
                    initialized: newState.initialized || !newState.strategyIDs.length || !newState.goalIDs.length || !newState.milestoneIDs.length || !newState.programIDs.length
                });
            }

            return newState;
        },
        strategyPlannerFilter: (state, action: Action<'SET_STRATEGY_PLANNER_FILTER'>) => {
            const defaultState = state || DefaultStrategyPlannerFilter;

            if (action.type === 'SET_STRATEGY_PLANNER_FILTER') {
                return action.payload.filter;
            }

            return defaultState;
        },
        strategyPlannerExpandedNodes: (state, action: Action<'SET_STRATEGY_PLANNER_EXPANDED_NODES'>) => {
            const initialState: string[] = [];

            if (action.type === 'SET_STRATEGY_PLANNER_EXPANDED_NODES') {
                return action.payload.expandedNodes;
            }

            return state || initialState;
        },
        strategyOrganizationStructureFilter: (state, action) => {
            const nextState = state || DefaultStrategyOrganizationStructureFilter;

            if (action.type === 'SET_STRATEGY_ORGANIZATION_STRUCTURE_FILTER') {
                return action.payload.filter;
            }

            return nextState;
        },
        timelineCollapsedGoalsIDs: (state, action: Action<'SET_STRATEGY_TIMELINE_COLLAPSED_GOALS'>) => {
            if (action.type === 'SET_STRATEGY_TIMELINE_COLLAPSED_GOALS') {
                return action.payload.goalIDs;
            }

            return state || [] as number[];
        },
        businessReviewSchedules: switchReducers(brs,
            entityLoadAllReducer(brs, 'LOAD_ALL_BUSINESS_REVIEW_SCHEDULES'),
            entityAddAllReducer(brs, 'ADD_ALL_BUSINESS_REVIEW_SCHEDULES')
        ),
        businessReviewTemplates: switchReducers(brts,
            entityLoadAllReducer(brts, 'LOAD_ALL_BUSINESS_REVIEW_TEMPLATES'),
            entityAddReducer(brts, 'ADD_BUSINESS_REVIEW_TEMPLATE'),
            childrenReducer(brts,
                combineReducers(defaults.BusinessReviewTemplateReport, {
                    Sessions: switchReducers(brss,
                        entityLoadAllReducer(brss, 'SEARCH_BUSINESS_REVIEW_SESSIONS_SLICE'),
                        entityLoadReducer(brss, 'LOAD_BUSINESS_REVIEW_SESSION'),
                        entityEditReducer(brss, 'EDIT_BUSINESS_REVIEW_SESSION')
                    ),
                    Steps: sortedEntitiesReducer(brsts, 'Sort', switchReducers(brsts,
                        entityAddReducer(brsts, 'ADD_BUSINESS_REVIEW_STEP'),
                        entityEditReducer(brsts, 'EDIT_BUSINESS_REVIEW_STEP'),
                        entityDeleteReducer(brsts, 'DELETE_BUSINESS_REVIEW_STEP')
                    ))
                }),
                (state, action) => state.Data.getIndexByID(action.payload && (action.payload as any).parentID)
            )
        ),
        businessReviewSessionStatuses: synchronizableEnumReducer(brsss, 'LOAD_ALL_BUSINESS_REVIEW_SESSION_STATUSES', BusinessReviewSessionStatus as any, 'BusinessReviewSessionStatus'),
        businessReviewDefaultUserSettings: switchReducers(brus,
            entityEditReducer(brus, 'EDIT_BUSINESS_REVIEW_DEFAULT_USER_SETTINGS'),
            (state, action) => {
                let nextState = state || brus;

                if (action.type === 'LOAD_BUSINESS_REVIEW_DEFAULT_USER_SETTINGS') {
                    nextState = deepAssign(nextState, {
                        Custom: {
                            status: action.payload.status,
                            expires: action.payload.status === RequestStatus.SUCCEEDED ? new Date(+new Date() + REDUCER_EXPIRATION_TIMEOUT) : undefined
                        }
                    });

                    if (action.payload.status && action.payload.response) {
                        return action.payload.response;
                    }

                    return nextState;
                }

                if (action.type === 'VOID_ALL_BUSINESS_REVIEW_DEFAULT_USER_SETTINGS') {
                    return brus;
                }

                return nextState;
            }
        ),
        businessReviewUserSettings: switchReducers(bruss,
            entityLoadReducer(bruss, 'LOAD_BUSINESS_REVIEW_USER_SETTINGS'),
            entityAddReducer(bruss, 'ADD_BUSINESS_REVIEW_USER_SETTINGS'),
            entityEditReducer(bruss, 'EDIT_BUSINESS_REVIEW_USER_SETTINGS'),
            (state, action) => {
                const newState = state || bruss;

                if (action.type === 'LOAD_BUSINESS_REVIEW_USER_SETTINGS' || action.type === 'MERGE_ALL_BUSINESS_REVIEW_USER_SETTINGS') {
                    return deepAssign(newState, {
                        Custom: {
                            status: action.payload.status,
                            expires: action.payload.status === RequestStatus.SUCCEEDED ? new Date(+new Date() + REDUCER_EXPIRATION_TIMEOUT) : undefined
                        }
                    });
                }

                if (action.type === 'VOID_ALL_BUSINESS_REVIEW_USER_SETTINGS') {
                    return bruss;
                }

                return newState;
            }
        ),
        businessReviewSectionTypes: synchronizableEnumReducer(
            defaults.NetworkArrayOf(defaults.BusinessReviewSectionType), 'LOAD_ALL_BUSINESS_REVIEW_SECTION_TYPES', BusinessReviewSectionType as any, 'BusinessReviewSectionType'
        ),
        businessReviewDefaultExcludedSections: switchReducers(bres,
            entityLoadAllReducer(bres, 'LOAD_ALL_BUSINESS_REVIEW_DEFAULT_EXCLUDED_SECTIONS'),
            (state, action) => {
                let nextState = state || bres;

                if (action.type === 'MERGE_ALL_BUSINESS_REVIEW_DEFAULT_EXCLUDED_SECTIONS') {
                    for (let entityIndex = 0; entityIndex < action.payload.entities.length; entityIndex++) {
                        const
                            entity = action.payload.entities[entityIndex],
                            oldEntity = nextState.Data.find(({ SectionTypeID }) => SectionTypeID === entity.SectionTypeID),
                            stateIndex = oldEntity ? nextState.Data.getIndexByID(oldEntity.ID) : nextState.Data.length;

                        nextState = deepAssign(nextState, {
                            Data: {
                                [stateIndex]: {
                                    ...entity,
                                    ID: action.payload.status === RequestStatus.SUCCEEDED ? action.payload.response[entityIndex] : oldEntity?.ID || entity.ID,
                                    Custom: {
                                        ...entity.Custom,
                                        status: action.payload.status
                                    }
                                }
                            }
                        });
                    }
                }

                return nextState;
            }
        ),
        businessReviewExcludedSections: switchReducers(bres,
            entityLoadAllReducer(bres, 'LOAD_USER_BUSINESS_REVIEW_EXCLUDED_SECTIONS'),
            entityAddReducer(bres, 'ADD_BUSINESS_REVIEW_EXCLUDED_SECTION'),
            entityEditReducer(bres, 'EDIT_BUSINESS_REVIEW_EXCLUDED_SECTION'),
            (state, action) => {
                const newState = state || bres;

                if (action.type === 'MERGE_ALL_BUSINESS_REVIEW_EXCLUDED_SECTIONS') {
                    return deepAssign(newState, {
                        Custom: { status: action.payload.status }
                    });
                }

                return newState;
            }
        ),
        businessReviewSettings: (state, action: Action<'SET_BUSINESS_REVIEW_SETTINGS'>) => {
            const initialState: BusinessReviewSettings = state || DefaultBusinessReviewSettings;

            if (action.type === 'SET_BUSINESS_REVIEW_SETTINGS') {
                return action.payload.settings;
            }

            return state || initialState;
        },
        strategyExecutionCustomFields: sortedEntitiesReducer(secf, 'Name', switchReducers(secf,
            entityLoadAllReducer(secf, 'LOAD_ALL_STRATEGY_EXECUTION_CUSTOM_FIELDS'),
            entityLoadReducer(secf, 'LOAD_STRATEGY_EXECUTION_CUSTOM_FIELD'),
            entityAddAllReducer(secf, 'ADD_ALL_STRATEGY_EXECUTION_CUSTOM_FIELDS'),
            entityEditAllReducer(secf, 'EDIT_ALL_STRATEGY_EXECUTION_CUSTOM_FIELDS'),
            entityDeleteAllReducer(secf, 'DELETE_ALL_STRATEGY_EXECUTION_CUSTOM_FIELDS'),
            entityDeleteReducer(secf, 'DELETE_STRATEGY_EXECUTION_CUSTOM_FIELD'),
            childrenReducer(secf,
                combineReducers(defaults.StrategyExecutionCustomFieldReport, {
                    Options: sortedEntitiesReducer(secfo, 'Sort', switchReducers(secfo,
                        entityAddAllReducer(secfo, 'ADD_ALL_STRATEGY_EXECUTION_CUSTOM_FIELD_OPTIONS'),
                        entityEditAllReducer(secfo, 'EDIT_ALL_STRATEGY_EXECUTION_CUSTOM_FIELD_OPTIONS'),
                        entityDeleteAllReducer(secfo, 'DELETE_ALL_STRATEGY_EXECUTION_CUSTOM_FIELD_OPTIONS')
                    ))
                }),
                (state, action) => state.Data.getIndexByID(action.payload && (action.payload as any).parentID)
            )
        )),
        strategyExecutionCustomFieldTypes: synchronizableEnumReducer(
            secft,
            'LOAD_ALL_STRATEGY_EXECUTION_CUSTOM_FIELD_TYPES',
            StrategyExecutionCustomFieldType as any,
            'StrategyExecutionCustomFieldType'
        ),
        strategyExecutionCustomEntities: entityLoadAllReducer(seces, 'LOAD_ALL_STRATEGY_EXECUTION_CUSTOM_ENTITIES'),
        strategySavedViews: sortedEntitiesReducer(ssva, 'Name', switchReducers(ssva,
            entityLoadAllReducer(ssva, 'LOAD_ALL_STRATEGY_SAVED_VIEWS'),
            entityAddReducer(ssva, 'ADD_STRATEGY_SAVED_VIEW'),
            entityEditReducer(ssva, 'EDIT_STRATEGY_SAVED_VIEW'),
            entityDeleteReducer(ssva, 'DELETE_STRATEGY_SAVED_VIEW')
        )),
        strategyUpdateRequest: networkActionReducer(defaults.NetworkObject, 'SEND_STRATEGIC_GOAL_MILESTONE_UPDATE_REQUEST_NOTIFICATION'),
        aggregatedStrategyEntities: (state, action) => {
            const nextState: { Reloadable: boolean; Milestones: number[]; Programs: number[]; } = state || {
                Reloadable: true,
                Milestones: [],
                Programs: []
            };

            if (action.type === 'LOAD_ALL_STRATEGIC_GOAL_MILESTONES' ||
                action.type === 'LOAD_ALL_STRATEGIC_GOAL_MILESTONES_QUIETLY') {
                return deepAssign(nextState, { Milestones: [] });
            }

            if (action.type === 'LOAD_MANY_STRATEGIC_GOAL_MILESTONES') {
                return deepAssign(nextState, { Milestones: nextState.Milestones.filter(milestoneID => !action.payload.entityIDs.includes(milestoneID)) });
            }

            if (action.type === 'LOAD_STRATEGIC_GOAL_MILESTONE') {
                return deepAssign(nextState, { Milestones: nextState.Milestones.filter(milestoneID => milestoneID !== action.payload.entityID) });
            }

            if (action.type === 'LOAD_ALL_STRATEGIC_PROGRAMS' ||
                action.type === 'LOAD_ALL_STRATEGIC_PROGRAMS_QUIETLY') {
                return deepAssign(nextState, { Programs: [] });
            }

            if (action.type === 'LOAD_MANY_STRATEGIC_PROGRAMS') {
                return deepAssign(nextState, { Programs: nextState.Programs.filter(programID => !action.payload.entityIDs.includes(programID)) });
            }

            if (action.type === 'LOAD_STRATEGIC_PROGRAM') {
                return deepAssign(nextState, { Programs: nextState.Programs.filter(programID => programID !== action.payload.entityID) });
            }

            return nextState;
        }
    }),
    def: ReturnType<typeof strategy> = strategy(undefined, {} as unknown as UntypedAction);

export default switchReducers(def,
    (state, action) => {
        const
            nextState = state || def,
            milestoneIDs = [],
            programIDs = [];

        let reloadable = true;

        if ((action.type === 'ADD_ALL_STRATEGIC_GOAL_MILESTONES' || action.type === 'EDIT_ALL_STRATEGIC_GOAL_MILESTONES') &&
            (action.payload.status === RequestStatus.UNSYNCED || action.payload.status === RequestStatus.SUCCEEDED)) {
            if (action.payload.status === RequestStatus.UNSYNCED) { reloadable = false; }
            milestoneIDs.push(...action.payload.entityIDs);
        }

        if ((action.type === 'ADD_STRATEGIC_GOAL_MILESTONE' ||
            action.type === 'EDIT_STRATEGIC_GOAL_MILESTONE' ||
            action.type === 'EDIT_STRATEGIC_GOAL_MILESTONE_AND_UPDATE_PROGRESS' ||
            action.type === 'PUBLISH_STRATEGIC_GOAL_MILESTONE' ||
            action.type === 'ARCHIVE_STRATEGIC_GOAL_MILESTONE' ||
            action.type === 'DELETE_STRATEGIC_GOAL_MILESTONE') &&
            (action.payload.status === RequestStatus.UNSYNCED || action.payload.status === RequestStatus.SUCCEEDED)) {
            if (action.payload.status === RequestStatus.UNSYNCED) { reloadable = false; }
            milestoneIDs.push(action.payload.entityID);
        }

        if ((action.type === 'ADD_STRATEGIC_GOAL_MILESTONE_STATUS_UPDATE' ||
            action.type === 'EDIT_STRATEGIC_GOAL_MILESTONE_STATUS_UPDATE' ||
            action.type === 'DELETE_STRATEGIC_GOAL_MILESTONE_STATUS_UPDATE') &&
            (action.payload.status === RequestStatus.UNSYNCED || action.payload.status === RequestStatus.SUCCEEDED)) {
            if (action.payload.status === RequestStatus.UNSYNCED) { reloadable = false; }
            milestoneIDs.push(action.payload.parentID);
        }

        if ((action.type === 'ADD_ALL_STRATEGIC_PROGRAMS' ||
            action.type === 'EDIT_ALL_STRATEGIC_PROGRAMS') &&
            (action.payload.status === RequestStatus.UNSYNCED || action.payload.status === RequestStatus.SUCCEEDED)) {
            if (action.payload.status === RequestStatus.UNSYNCED) { reloadable = false; }
            programIDs.push(...action.payload.entityIDs);
        }

        if ((action.type === 'ADD_STRATEGIC_PROGRAM' ||
            action.type === 'EDIT_STRATEGIC_PROGRAM' ||
            action.type === 'DELETE_STRATEGIC_PROGRAM') &&
            (action.payload.status === RequestStatus.UNSYNCED || action.payload.status === RequestStatus.SUCCEEDED)) {
            if (action.payload.status === RequestStatus.UNSYNCED) { reloadable = false; }
            programIDs.push(action.payload.entityID);
        }

        if ((action.type === 'ADD_STRATEGIC_PROGRAM_STATUS_UPDATE' ||
            action.type === 'EDIT_STRATEGIC_PROGRAM_STATUS_UPDATE' ||
            action.type === 'DELETE_STRATEGIC_PROGRAM_STATUS_UPDATE') &&
            (action.payload.status === RequestStatus.UNSYNCED || action.payload.status === RequestStatus.SUCCEEDED)) {
            if (action.payload.status === RequestStatus.UNSYNCED) { reloadable = false; }
            programIDs.push(action.payload.parentID);
        }

        if (milestoneIDs.length || programIDs.length) {
            const
                milestoneEntityType = defaults.StrategicGoalMilestoneReport.EntityType,
                programEntityType = defaults.StrategicProgramReport.EntityType,

                milestones = nextState.strategicGoalMilestones.Data,
                programs = nextState.strategicPrograms.Data,
                previousState = nextState.aggregatedStrategyEntities;

            let expiredHierarchy: (entities.StrategicGoalMilestoneReport | entities.StrategicProgramReport)[] = [
                ...milestoneIDs.unique().map(milestoneID => milestones.getByID(milestoneID)!).filter(v => v),
                ...programIDs.unique().map(programID => programs.getByID(programID)!).filter(v => v)
            ];

            for (let entityIndex = 0; entityIndex < expiredHierarchy.length; entityIndex++) {
                const entity = expiredHierarchy[entityIndex];
                let relatedEntities: (entities.StrategicGoalMilestoneReport | entities.StrategicProgramReport)[] = [];

                if (entity.EntityType === milestoneEntityType) {
                    relatedEntities = [
                        ...milestones.filter(({ ID, FatherID }) => ID === entity.FatherID || ID === entity.ConnectedToMilestoneID || FatherID === entity.ID),
                        ...programs.filter(({ ID, ParentMilestoneID, FatherID }) =>
                            ID === entity.ParentProgramID || ID === entity.ConnectedToProgramID || ParentMilestoneID === entity.ID && !FatherID
                        )
                    ];
                }
                else if (entity.EntityType === programEntityType) {
                    relatedEntities = [
                        ...milestones.filter(({ ID, ParentProgramID }) => ID === entity.ParentMilestoneID || ID === entity.ConnectedToMilestoneID || ParentProgramID === entity.ID),
                        ...programs.filter(({ ID, FatherID }) => ID === entity.FatherID || ID === entity.ConnectedToProgramID || FatherID === entity.ID)
                    ];
                }

                // eslint-disable-next-line no-loop-func
                relatedEntities = relatedEntities.filter(({ EntityType, ID }) => !expiredHierarchy.some(entity => entity.EntityType === EntityType && entity.ID === ID));
                expiredHierarchy.push(...relatedEntities);
            }

            const deleting = action.type === 'DELETE_STRATEGIC_GOAL_MILESTONE' || action.type === 'DELETE_STRATEGIC_PROGRAM';
            if (deleting) {
                const
                    deletedMilestoneHierarchy = milestoneIDs
                        .map((milestoneID, _, __, milestone = milestones.getByID(milestoneID)) =>
                            milestone ? [milestone, ...getMilestoneChildren(milestone, milestones, programs)] : []
                        )
                        .flatten(),
                    deletedProgramHierarchy = programIDs
                        .map((programID, _, __, program = programs.getByID(programID)) => program ? [program, ...getProgramChildren(program, milestones, programs)] : [])
                        .flatten();

                expiredHierarchy = expiredHierarchy.filter(({ ID, EntityType }) =>
                    !deletedMilestoneHierarchy.some(entity => entity.EntityType === EntityType && entity.ID === ID) ||
                    !deletedProgramHierarchy.some(entity => entity.EntityType === EntityType && entity.ID === ID)
                );
            }

            return deepAssign(nextState, {
                aggregatedStrategyEntities: {
                    Reloadable: reloadable,
                    Milestones: [...previousState.Milestones, ...expiredHierarchy.filter(({ EntityType }) => EntityType === milestoneEntityType).map(({ ID }) => ID)].unique(),
                    Programs: [...previousState.Programs, ...expiredHierarchy.filter(({ EntityType }) => EntityType === programEntityType).map(({ ID }) => ID)].unique()
                }
            });
        }

        return nextState;
    },
    strategy,
    (state, _action) => {
        const
            nextState = state || def,
            { Milestones, Programs } = nextState.aggregatedStrategyEntities;

        return deepAssign(nextState, {
            aggregatedStrategyEntities: {
                Milestones: Milestones.filter(milestoneID => !!nextState.strategicGoalMilestones.Data.getByID(milestoneID)),
                Programs: Programs.filter(programID => !!nextState.strategicPrograms.Data.getByID(programID))
            }
        });
    }
);
